import { render } from "./UserForm.vue?vue&type=template&id=c6de4918&scoped=true"
import script from "./UserForm.vue?vue&type=script&lang=ts"
export * from "./UserForm.vue?vue&type=script&lang=ts"

import "./UserForm.vue?vue&type=style&index=0&id=c6de4918&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-c6de4918"

export default script